import { NgModule } from '@angular/core';
import { ReportListComponent } from './report-list/report-list.component';
import { SharedModule } from '../shared/shared.module';
import { ReportListService } from '../core/service/grid-data/grid-data-report.service';
import { ReportEditComponent } from './report-edit/report-edit.component';
import { ReportGridComponent } from './report-grid/report-grid.component';
import { ReportResultListService } from '../core/service/grid-data/grid-data-report-result.service';
import { FilterModule } from '@progress/kendo-angular-filter';

@NgModule({
  declarations: [
    ReportListComponent,
    ReportEditComponent,
    ReportGridComponent
  ],
  imports: [
    SharedModule,
    FilterModule
  ],
  providers: [
    ReportListService,
    ReportResultListService
  ]
})
export class ReportModule { }
